module.exports = __webpack_public_path__ + "static/media/evoUSDC.90963e08.svg";